import { Link } from "react-router-dom";
import { Mark } from "./Mark";
import { useSectionNav } from "./Nav";

const QUICK = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "services", label: "Our Services" },
  { id: "contact", label: "Contact Us" },
];

const Head = ({ children }) => <p className="font-mono-d mb-5 text-[11px] uppercase tracking-[0.22em] text-[#D4AF37]">{children}</p>;

export const Footer = () => {
  const go = useSectionNav();
  return (
    <footer className="relative overflow-hidden border-t border-[rgba(212,175,55,0.15)] bg-[#070E17] pt-20" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3"><Mark className="h-11 w-11" /><span className="font-serif-d text-2xl text-white">VK Enterprises</span></div>
          <p className="mt-2 text-sm text-[#E6C280]">Property Consultancy &amp; Real Estate Marketing</p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-300">Real-estate marketing and lead-generation support for selected opportunities in the United States, United Kingdom and Netherlands.</p>
        </div>
        <div className="lg:col-span-2">
          <Head>Quick links</Head>
          <ul className="space-y-3">
            {QUICK.map((q) => (
              <li key={q.id}><button onClick={() => go(q.id)} className="text-sm text-slate-300 transition-colors duration-300 hover:text-[#E6C280]" data-testid={`footer-link-${q.id}`}>{q.label}</button></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <Head>Contact</Head>
          <a href="mailto:support@vkenterpriseconsult.com" className="block text-sm text-slate-300 hover:text-[#E6C280]" data-testid="footer-email">support@vkenterpriseconsult.com</a>
          <a href="tel:+918796881958" className="mt-3 block text-sm text-slate-300 hover:text-[#E6C280]" data-testid="footer-phone">+91 87968 81958</a>
        </div>
        <div className="lg:col-span-2">
          <Head>Legal</Head>
          <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" className="text-slate-300 hover:text-[#E6C280]" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-slate-300 hover:text-[#E6C280]" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
            <li><button onClick={() => go("contact")} className="text-slate-300 hover:text-[#E6C280]" data-testid="footer-contact-link">Contact Us</button></li>
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-16 max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <p className="border-t border-[rgba(212,175,55,0.15)] pt-8 text-xs leading-relaxed text-slate-400" data-testid="footer-disclaimer">
          <span className="text-[#E6C280]">Disclaimer:</span> VK Enterprises provides property marketing and enquiry-support services. Any relationship with a property developer, broker, or real-estate brand should be described accurately. Unless formally authorized, VK Enterprises does not represent itself as an official partner or agent of any third-party brand.
        </p>
        <p className="mt-6 text-xs text-slate-400">© {new Date().getFullYear()} VK Enterprises. All rights reserved.</p>
      </div>
      <p className="font-serif-d outline-text pointer-events-none mt-10 select-none whitespace-nowrap text-center text-[12.5vw] leading-[0.85]" aria-hidden="true">VK Enterprises</p>
    </footer>
  );
};
